import * as React from "react";
import Auth from "@aws-amplify/auth";
import Button from "@material-ui/core/Button";
import Instructions from "./Instructions";
import Alerts from "./Alerts";
import logo from "../images/JAT_v2_digital.png";
import { withRouter, RouteComponentProps } from "react-router-dom";

interface HeaderProps extends RouteComponentProps {
  wait: boolean;
  created: boolean;
  deleted: boolean;
  notPossible: boolean;
}

const Header = function Header(props: HeaderProps) {
  const signOut = () => {
    Auth.signOut().then(() => {
      props.history.push("/login/");
    });
  };

  return (
    <header className="App-header">
      <Button
        variant="contained"
        color="primary"
        className="App-button"
        onClick={signOut}
      >
        {"Kirjaudu ulos"}
      </Button>
      <img src={logo} alt="JAT Logo" className="App-logo" />
      <h1 className="App-h1">JAT kenttävaraus</h1>
      <Instructions />
      <Alerts
        wait={props.wait}
        created={props.created}
        deleted={props.deleted}
        notPossible={props.notPossible}
      />
    </header>
  );
};
export default withRouter(Header);
